import { ThemeOptions } from '@material-ui/core';

const baseOverrides = {
    MuiDialog: {
        root: {
        },
    },
    MuiBackdrop: {
        root: {
            display: 'block',
            position: 'absolute',
        },
    },
    MuiButton: {
        root: {
        },
    },
    MuiContainer: {
        root: {
            'overscroll-behavior': 'contain',
        },
    },
    MuiInputLabel: {
        root: {
            zIndex: 'auto',
        },
    },
    MuiCardHeader: {
        action: {
            alignSelf: 'unset',
            marginTop: 'unset',
        },
    },
};

/**
 * https://themes.material-ui.com/
 * https://material-ui.com/customization/default-theme/
 * https://material.io/resources/color/#!/?view.left=0&view.right=0&primary.color=c24f00&secondary.color=214563
 */
const baseTheme = {
    overrides: {
        ...baseOverrides,
    },

} as ThemeOptions;

export default baseTheme;